/**
 * Created by rhinov4 on 16/09/2015.
 */

import { GameObjectManager } from "./plan/GameObjectManager";
import { GUIConstants } from "./utils/GUIConstants";
import { Utils } from "./utils/Utils";
import { ActionStateEnum, AddRoomState, IdleVisualiseState } from "./state";
import { EntityManager } from "./plan/EntityManager";
import { PlanManager } from "../../cocosPlan";
import { Grid } from "./plan/grid";
import { ComponentConstants, Events, eventsManager, Listener, math } from "@rhinov/savane-js";

declare var cc: any;
declare var $: any;

export class ScrollWindow extends cc.ScrollView {

    scroll_zone : number= 50;
    isLeftClickDown: boolean = false;
    zoomscale: number = 1.0;
    zoomindex: number = 15;
    lastzoomindex_labelupdate: number = -1;
    scrollAccumulator: number = 0;

    zoom_animation_target: number = 1.0;
    zoom_in_progress: boolean = false;

    mouse_x: number = 0;
    mouse_y: number = 0;

    translate_x: number = 0;
    translate_y: number = 0;

    _use_desktop_controls: boolean = true;
    _dragging: boolean = false;
    _dragStartX: number =  0;
    _dragStartY: number =  0;
    _currentTranslationX: number =  0;
    _currentTranslationY: number =  0;
    grid: Grid

    constructor(size: number, grid: Grid) {
        super(size, grid);
        this.touchMode = false;
        this.size = size;
        this._minScale = 0.1;
        this._maxScale = 10.0;
        this.minzoomindex = 9;//14;
        this.maxzoomindex = 61;//28;
        this.zoomindex = 30;
        this.DRAG_SPEED = 5;
        this.grid = grid;
        //Variable used to calculate click duration
        this.downTime = null;
        this.touches = [];
        this.lastClickTime = new Date();
        this.lastButton = null;

        this.isDragging = false;
        this.posToUpdate = cc.p(0, 0);

        this.velocityDragX = 0;
        this.velocityDragY = 0;

        this.buildZoomScale();
        this.addListeners();

        if (cc.sys.isMobile && cc.sys.isNative) {
            //Reset boudary of zoom in native class
            this.setMaxScale(10);
            this.setMinScale(0.1);
        }
        //Listener for Zoom events
        var zoomInFunction = (event: any) => {
            if (this.zoomindex < this.maxzoomindex) {
                this.zoomindex = this.zoomindex + 1;
                //this.setTouchPosition(new cc.p(this.width * 0.5, this.height * 0.5));
                this.setTouchPosition(new cc.p(this.getContentSize().width * 0.50, this.getContentSize().height * 0.5));
                this.setZoomScale(this.zoomfactors[this.zoomindex]);
                this.rebuildGrid(this.getZoomScale());
            }
        };
        this.zoomInEvent = new Listener(zoomInFunction);
        eventsManager.instance.addListenerObject(Events.ZOOM_IN_EVENT, this.zoomInEvent);

        var zoomOutFunction = (event: any) => {
            if (this.zoomindex > this.minzoomindex) {
                this.zoomindex = this.zoomindex - 1;
                this.setTouchPosition(new cc.p(this.getContentSize().width * 0.50, this.getContentSize().height * 0.5));
                this.setZoomScale(this.zoomfactors[this.zoomindex]);
                this.rebuildGrid(this.getZoomScale());
            }
        };
        this.zoomOutEvent = new Listener(zoomOutFunction);
        eventsManager.instance.addListenerObject(Events.ZOOM_OUT_EVENT, this.zoomOutEvent);

        this.overWebGlView = eventsManager.instance.addListener(Events.DRAG_OVER_WEBGL, function () {
            PlanManager.getInstance().mouseClickCancelled();
        });
    }

     updateTweenAction (value: number, key: string) {
        if (key === 'zoomScale') {
            if (value === this.zoom_animation_target) {
                this.zoom_in_progress = false;
            } else {
                this.setZoomScale(value);
            }
            this.rebuildGrid(this.getZoomScale());
        }
    }

    setTouchPosition (position: math.vec3) {
        this._touchPoint = position;
        this._touchLength = 0.1;
    }

    update (dt: number, skip?: boolean) {
        super.update(dt);
    }

    buildZoomScale (factor?: number): number[] {
        var i;
        this.zoomfactors = [];
        //first layer for large view index: 0-20
        var scale = factor === undefined ? 1.0 : factor;
        var zoom = 0.001 * scale;

        this.zoomfactors.push(zoom);
        for (i = 0; i < 19; i++) {
            zoom += 0.0144 * scale;
            this.zoomfactors.push(zoom);
        }
        //second layer for plan edition 20-46
        for (i = 0; i < 41; i++) {
            zoom *= 1.111;
            this.zoomfactors.push(zoom);
        }
        //third layer for micro view  46-61;
        for (i = 0; i < 15; i++) {
            zoom *= 1.1;
            this.zoomfactors.push(zoom);
        }
        this._minScale = this.zoomfactors[0];
        this._maxScale = this.zoomfactors[this.zoomfactors.length - 1];
        return this.zoomfactors;
    }

    getScrollPosition () {
        var pos = this.grid.getPosition();
        var zoom = this.getZoomScale();
        return cc.p(pos.x / zoom, pos.y / zoom);
    }

    rebuildGrid (zoom: number) {
        if (this.grid !== null)
            this.grid.rebuildGrid(zoom);

        if (this.zoomindex !== this.lastzoomindex_labelupdate) {
            //console.log('zoom level has changed!');
            this.lastzoomindex_labelupdate = this.zoomindex;

            var mainScene = cc.director.getRunningScene();
            if (!mainScene) {
                return;
            }
            var scrollwindow = mainScene.getChildByName('ScrollWindow');

            if (scrollwindow !== null) {
                var plan = PlanManager.getInstance();
                // XXX: we use GameObjectManager.selectItems to redraw every selected dimension correctly when zooming...
                GameObjectManager.selectItems(plan.selectedWalls/*, plan.selectedJoineries, plan.selectedRooms*/);
            }
        }
    }
    centerPosition (lock?: boolean, offsetLateralPanel?: boolean): {width: number, height: number} {
        this.setZoomScale(1.0);
        //Calculate center of all walls
        var walls = PlanManager.getInstance().world.currentScene!.currentFloor!.walls;
        var topLeft = math.vec3.create();
        var botRight = math.vec3.create();
        var topLeftCocos = null;// GameObjectManager.convertToCocosCoord(topLeft);
        var botRightCocos = null;// GameObjectManager.convertToCocosCoord(botRight);
        var scrollWindow = PlanManager.getInstance().scrollWindow;
        var userMap = scrollWindow.grid.getChildByName('UserMap');
        if (walls.length > 0) {
            topLeft[0] = Math.min(walls[0].begin[0], walls[0].end[0]);
            botRight[0] = Math.max(walls[0].begin[0], walls[0].end[0]);
            topLeft[1] = Math.min(walls[0].begin[1], walls[0].end[1]);
            botRight[1] = Math.max(walls[0].begin[1], walls[0].end[1]);
            for (var i = 0; i < walls.length; i++) {
                topLeft[0] = Math.min(topLeft[0], walls[i].end[0]);
                botRight[0] = Math.max(botRight[0], walls[i].end[0]);
                topLeft[1] = Math.min(topLeft[1], walls[i].end[1]);
                botRight[1] = Math.max(botRight[1], walls[i].end[1]);
                topLeft[0] = Math.min(topLeft[0], walls[i].begin[0]);
                botRight[0] = Math.max(botRight[0], walls[i].begin[0]);
                topLeft[1] = Math.min(topLeft[1], walls[i].begin[1]);
                botRight[1] = Math.max(botRight[1], walls[i].begin[1]);
            }
            topLeftCocos = GameObjectManager.convertToCocosCoord(topLeft);
            botRightCocos = GameObjectManager.convertToCocosCoord(botRight);
        } else {
            var floorComp = PlanManager.getInstance().world.currentScene!.currentFloor!.getComponent(ComponentConstants.ComponentType.TemplateImage);
            if (floorComp === null) {
                topLeft[0] = -100;
                botRight[0] = 100;
                topLeft[1] = -100;
                botRight[1] = 100;
                topLeftCocos = GameObjectManager.convertToCocosCoord(topLeft);
                botRightCocos = GameObjectManager.convertToCocosCoord(botRight);
            } else {

                if (userMap !== null && userMap.children[0].texture !== null) {
                    var size = userMap.children[0].texture.getContentSize();
                    topLeft[0] = -size.width * 0.5 * userMap.children[0].realScale;
                    botRight[0] = size.width * 0.5 * userMap.children[0].realScale;
                    topLeft[1] = -size.height * 0.5 * userMap.children[0].realScale;
                    botRight[1] = size.height * 0.5 * userMap.children[0].realScale;
                    topLeftCocos = new cc.p(topLeft[0], topLeft[1]);
                    botRightCocos = new cc.p(botRight[0], botRight[1]);
                } else {
                    topLeft[0] = -100;
                    botRight[0] = 100;
                    topLeft[1] = -100;
                    botRight[1] = 100;
                    topLeftCocos = GameObjectManager.convertToCocosCoord(topLeft);
                    botRightCocos = GameObjectManager.convertToCocosCoord(botRight);
                }
            }


        }

        var contentSize = this.grid.getContentSize();
        if (offsetLateralPanel) {
            contentSize.width -= GUIConstants.LATERAL_PANEL_SIZE;
        }
        //Convert to cocos coord
        var distanceX = botRightCocos.x - topLeftCocos.x;
        var distanceY = botRightCocos.y - topLeftCocos.y;

        var zoomX = (contentSize.width / (distanceX)) * 0.85;
        var zoomY = (contentSize.height / (distanceY)) * 0.80;

        var center = new cc.p(-(topLeftCocos.x + (botRightCocos.x - topLeftCocos.x) * 0.5), -(topLeftCocos.y + (botRightCocos.y - topLeftCocos.y) * 0.5));

        if (lock !== undefined && lock) {
            this.grid.lockGrid(new cc.p(center.x, center.y), new cc.p(distanceX * 0.55, distanceY * 0.55));
        }

        center.x += contentSize.width * 0.5;
        center.y += contentSize.height * 0.5;


        this.grid.setPosition(center);
        //Set Zoom to closest scale value
        this.setTouchPosition(new cc.p(contentSize.width * 0.50, contentSize.height * 0.50));
        if (walls.length > 0 || userMap !== null) {
            this.zoomindex = this.getClosestZoomIndex(Math.min(zoomX, zoomY));
        }
        this.setZoomScale(this.zoomfactors[this.zoomindex]);
        this.rebuildGrid(this.getZoomScale());
        return {
            width: Math.abs(distanceX) / contentSize.width * this.getZoomScale(),
            height: Math.abs(distanceY) / contentSize.height * this.getZoomScale()
        };
    }

    centerOn (x: number, y: number, w: number, h: number, scaleX: number, scaleY: number, contentW: number, contentH: number): {width: number, height: number} {
        this.setZoomScale(1.0);
        var contentSize = this.grid.getContentSize();
        var zoomX = ((contentW ? contentW : contentSize.width) / (w)) * (scaleX ? scaleX : 0.85);
        var zoomY = ((contentH ? contentH : contentSize.height) / (h)) * (scaleY ? scaleY : 0.80);
        //this.setZoomScale(1.0, false);
        var center = new cc.p(-(x - w * 0.5), -(y - h * 0.5));
        //var center = new cc.p( x, y );
        center.x += (contentW ? contentW : contentSize.width) * 0.5;
        center.y += (contentH ? contentH : contentSize.height) * 0.5;

        this.grid.setPosition(center);
        //Set Zoom to closest scale value
        this.setTouchPosition(new cc.p((contentW ? contentW : contentSize.width) * 0.50, (contentH ? contentH : contentSize.height) * 0.50));
        this.zoomindex = this.getClosestZoomIndex(Math.min(zoomX, zoomY));
        this.setZoomScale(this.zoomfactors[this.zoomindex]);
        this.rebuildGrid(this.getZoomScale());
        return {
            width: w / (contentW ? contentW : contentSize.width) * this.getZoomScale(),
            height: h / (contentH ? contentH : contentSize.height) * this.getZoomScale()
        };
    }

    _startDragging (posX: number, posY: number, convertToWorldSpace: boolean) {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        var p = new cc.p(posX, posY);
        if (convertToWorldSpace === true) p = this.grid.convertToWorldSpace(p);
        this._dragging = true;
        this._dragStartX = p.x;
        this._dragStartY = p.y;
        this._currentTranslationX = this.grid.getPositionX();
        this._currentTranslationY = this.grid.getPositionY();
    }

    _mouseDragging (posX: number, posY: number, convertToWorldSpace: boolean) {
        if (this._dragging) {
            eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
            var p = new cc.p(posX, posY);
            if (convertToWorldSpace === true) p = this.grid.convertToWorldSpace(p);
            this.grid.setPosition(cc.p(this._currentTranslationX + p.x - this._dragStartX, this._currentTranslationY + p.y - this._dragStartY));
            this.grid.rebuildGrid(this.getZoomScale());

            //Notify that grid has moved
            var cSize = this.getContentSize();
            var position = cc.p(cSize.width * 0.5, cSize.height * 0.5);
            var localPosition = this.grid.convertToNodeSpace(position);
            eventsManager.instance.dispatch(Events.POS_WIN_CHANGED, {
                x: localPosition.x,
                y: localPosition.y,
                zoom: this.getZoomScale()
            });
        }
    }

    _endDragging (posX: number, posY: number, convertToWorldSpace: boolean) {
        if (this._dragging) {
            var p = new cc.p(posX, posY);
            if (convertToWorldSpace === true) p = this.grid.convertToWorldSpace(p);
            this.grid.setPosition(cc.p(this._currentTranslationX + p.x - this._dragStartX, this._currentTranslationY + p.y - this._dragStartY));
            this.grid.rebuildGrid(this.getZoomScale());
        }
        this._dragging = false;
        eventsManager.instance.dispatch(Events.START_UPDATING_ENVS);
    }

    _cancelDragging () {
        this._dragging = false;
    }
    getClosestZoomIndex (zoomValue: number): number {
        var newZoom = zoomValue;
        var closestZoomIndex = this.zoomindex;
        var closestDist = Math.abs(newZoom - this.zoomscale);
        for (var i = this.minzoomindex; i < this.maxzoomindex; i++) {
            var currentDist = Math.abs(newZoom - this.zoomfactors[i]);
            if (currentDist < closestDist) {
                closestZoomIndex = i;
                closestDist = currentDist;
            }
        }

        return closestZoomIndex;
    }
    toZoom (ratio: number, zoomCenter: math.vec3) {
        this._dragging = false; // disable dragging while zooming!

        var newZoom = this.zoomscale * ratio;

        this.zoomindex = this.getClosestZoomIndex(newZoom);

        newZoom = this.zoomfactors[this.zoomindex];
        if (zoomCenter !== undefined) this.setTouchPosition(zoomCenter);
        this.setZoomScale(newZoom);
        this.rebuildGrid(this.getZoomScale());
    }

    resize (width: number, height: number) {
        this.setContentSize(width, height);
        this.setZoomScale(this.zoomfactors[this.zoomindex]);
        this.grid.changeWidthAndHeight(width, height);
        this.rebuildGrid(this.getZoomScale());
    }

    _onMouseUp (event: any): boolean {
        if (!this.isVisible()) {
            return false;
        }
        if (this.touchMode === true) {
            this.touchMode = false;
            return false;
        }
        if (this.downTime === null)
            return false;
        var dateNow = new Date();
        var elapsedTime = dateNow.getTime() - this.downTime.getTime();
        var button = event.getButton();
        var target = event.getCurrentTarget();
        target.mouse_x = event.getLocationX();
        target.mouse_y = event.getLocationY();

        var width = $('#gameCanvas').width();
        var height = $('#gameCanvas').height();
        if (target.mouse_x < 0 || target.mouse_x > width ||
            target.mouse_y < 0 || target.mouse_y > height) {
            return false;
        }

        var pos = new cc.p(event.getLocationX(), event.getLocationY());
        PlanManager.getInstance().mouseClickUp(pos, elapsedTime);

        eventsManager.instance.dispatch(Events.START_UPDATING_ENVS);
        return true;
    }

    _onMouseDown(event: any): boolean {
        if (!this.isVisible()) {
            return false;
        }
        var button = event.getButton();
        //Save mouse button pressed to handle behaviour for each button
        PlanManager.getInstance().mouseButton = button;

        this.downTime = new Date();
        var target = event.getCurrentTarget();
        var positionX = target.getPositionX();
        var pos = new cc.p(event.getLocationX(), event.getLocationY());
        target.mouse_x = pos.x;
        target.mouse_y = pos.y;

        var width = $('#gameCanvas').width();
        var height = $('#gameCanvas').height();
        if (target.mouse_x < 0 || target.mouse_x > width ||
            target.mouse_y < 0 || target.mouse_y > height) {
            return false;
        }

        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        var curDate = new Date();
        var isDoubleClick = (curDate.getTime() - this.lastClickTime.getTime()) < 300 && (this.lastButton === button);
        this.lastClickTime = new Date();
        this.lastButton = button;

        if (pos.x > positionX) {
            PlanManager.getInstance().moveMouseCursor(pos);
            if (button !== undefined) {
                PlanManager.getInstance().mouseClickDown(pos, isDoubleClick, button);
            }
        }

        return true;
    }

    _onMouseMove (event: any): boolean {
        if (!this.isVisible()) {
            return false;
        }

        if (this.touchMode === true) {
            return false;
        }

        var target = event.getCurrentTarget();
        target.mouse_x = event.getLocationX();
        target.mouse_y = event.getLocationY();

        var width = $('#gameCanvas').width();
        var height = $('#gameCanvas').height();
        var action = PlanManager.getInstance().state.getAction();
        if ((action === ActionStateEnum.addRoom && (PlanManager.getInstance().state as unknown as AddRoomState).isRoomCreated) || action === ActionStateEnum.createWall ||
            action === ActionStateEnum.createMultipleWalls || action === ActionStateEnum.editPoint ||
            action === ActionStateEnum.editWall) {

            if (target.mouse_x > 0 && target.mouse_x < width &&
                target.mouse_y > 0 && target.mouse_y < height) {
                this.posToUpdate = cc.p(target.mouse_x, target.mouse_y);
                if (target.mouse_x < Utils.startDraggingConstant ||
                    width - target.mouse_x < Utils.startDraggingConstant) {
                    if (width - target.mouse_x < target.mouse_x) {
                        this.velocityDragX = -this.DRAG_SPEED;
                    } else {
                        this.velocityDragX = this.DRAG_SPEED;
                    }

                } else {
                    this.velocityDragX = 0;
                }
                if (target.mouse_y < Utils.startDraggingConstant || height - target.mouse_y < Utils.startDraggingConstant) {
                    if (height - target.mouse_y < target.mouse_y) {
                        this.velocityDragY = -this.DRAG_SPEED;
                    } else {
                        this.velocityDragY = this.DRAG_SPEED;
                    }
                } else {
                    this.velocityDragY = 0;
                }
                if (this.velocityDragY !== 0 || this.velocityDragX !== 0) {
                    if (!this.isDragging) {
                        this.isDragging = true;
                    }

                } else if (this.isDragging) {
                    this.isDragging = false;
                    this.velocityDragY = 0;
                    this.velocityDragX = 0;
                }
            }
        } else {
            if (this.isDragging) {
                this.velocityDragY = 0;
                this.velocityDragX = 0;
                this.isDragging = false;
            }
        }

        if (event._button != null) {
            eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        }
        var pos = new cc.p(event.getLocationX(), event.getLocationY());
        if (pos.x < this.size.width * 1.001) {
            PlanManager.getInstance().moveMouseCursor(pos);
        }
        return false;
    }

    _onMouseScroll (event: any): void {
        if (!this.isVisible()) {
            return;
        }

        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        var target = event.getCurrentTarget();

        target.mouse_x = event.getLocationX();
        target.mouse_y = event.getLocationY();
        // TODO : dirty update (replace MainUIConstantes.rightBarSize by 300)
        if (target.mouse_x < this.getContentSize().width) {
            var val = Math.abs(event.getScrollY());
            if (val === 0) {
                val = 1;
            }
            target.scrollAccumulator += Math.ceil(event.getScrollY() / val);

            if (!target.zoom_in_progress) {
                target.zoomindex += target.scrollAccumulator;
                target.scrollAccumulator = 0;

                if (target.zoomindex < target.minzoomindex) target.zoomindex = target.minzoomindex;
                if (target.zoomindex > target.maxzoomindex) target.zoomindex = target.maxzoomindex;

                var zoom = target.zoomfactors[target.zoomindex];
                //target.zoom_in_progress = true;
                target.zoom_animation_target = zoom;
                if (PlanManager.getInstance().state.getAction() != ActionStateEnum.idleVisualise || PlanManager.getInstance().state.getAction() != ActionStateEnum.RoomsValidation) {
                    target.setTouchPosition(new cc.p(target.mouse_x, target.mouse_y));
                } else {
                    target.setTouchPosition(new cc.p(target.getContentSize().width / 2, target.getContentSize().height / 2));
                }
                target.setZoomScale(zoom, false);
                target.rebuildGrid(this.getZoomScale());
            }
        }
    }

    addListeners () {
        this.cocosListener = cc.EventListener.create({
            event: cc.EventListener.MOUSE,
            swallowTouches: false,
            onMouseUp: this._onMouseUp.bind(this),
            onMouseDown: this._onMouseDown.bind(this),
            onMouseMove: this._onMouseMove.bind(this),
            onMouseScroll: this._onMouseScroll.bind(this)
        });
        cc.eventManager.addListener(this.cocosListener, this);
    }


    generateScreenshot (alpha: number, screenWidth: number, screenHeight: number, presetFunc: CallableFunction): Uint8Array | null {
        var i;
        if (PlanManager.getInstance().world.currentScene!.currentFloor!.walls.length === 0) {
            return null;
        }
        var previousZoom = this.getZoomScale();
        var previousPos = this.grid.getPosition();
        var previousState = PlanManager.getInstance().state;
        var userMap = this.grid.getChildByName('UserMap');
        var userMapShowed = false;
        if (userMap) {
            userMapShowed = userMap.isVisible();
            userMap.setVisible(false);
        }
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (i = 0; i < rooms.length; i++) {
            GameObjectManager.drawScreenshotRoom(rooms[i]);
        }
        PlanManager.getInstance()._state = new IdleVisualiseState() as any;
        (PlanManager.getInstance()._state as any).lockViewNoOffset();
        if (presetFunc !== undefined) {
            //Execute preset
            presetFunc();
        }

        //var rawData = null;
        var gameCanvas = document.getElementById('gameCanvas') as HTMLCanvasElement;
        if (gameCanvas === null || gameCanvas === undefined) {
            return null;
        }

        var renderer = new cc.RenderTexture(gameCanvas.width, gameCanvas.height);
        renderer.setAutoDraw(true);
        renderer.x = 0;
        renderer.y = 0;

        renderer.beginWithClear(255, 255, 255, alpha, 0, 0);
        this.grid.visit();
        renderer.end();

        for (i = 0; i < rooms.length; i++) {
            EntityManager.getInstance().getNode(rooms[i])!.screenshot = false;
        }
        var html = renderer.sprite.texture.getHtmlElementObj();
        var canvas = document.createElement('canvas');
        var rate = 1.0;
        if (screenWidth && screenHeight) {
            rate = (400 / gameCanvas.width);
            if (rate > 300 / gameCanvas.height) {
                rate = 300 / gameCanvas.height;
            }
        }
        canvas.width = gameCanvas.width * rate;
        canvas.height = gameCanvas.height * rate;
        if (canvas.width === 0 || canvas.height === 0) return null;
        var ctx = canvas.getContext('2d');
        if (!ctx) return null;
        ctx.drawImage(html, 0, 0, canvas.width, canvas.height);

        var base64: string = '';
        if (alpha === 255) {
            base64 = canvas.toDataURL('image/jpeg').substr('data:image/jpeg;base64,'.length);
        } else {
            base64 = canvas.toDataURL('image/png').substr('data:image/png;base64,'.length);
        }


        var byteCharacters = atob(base64);

        var byteNumbers = new Array(byteCharacters.length);
        for (i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);

        var rawData = byteArray;


        PlanManager.getInstance()._state.dispose();
        PlanManager.getInstance()._state = previousState;

        this.zoomindex = this.getClosestZoomIndex(previousZoom);
        this.setZoomScale(this.zoomfactors[this.zoomindex]);
        this.grid.setPosition(previousPos);
        this.rebuildGrid(this.getZoomScale());
        if (userMap) {
            userMap.setVisible(userMapShowed);
        }
        for (i = 0; i < rooms.length; i++) {
            GameObjectManager.drawRoom(rooms[i]);
        }
        return rawData;
    }

    refreshGrid () {
        this.setZoomScale(this.zoomfactors[this.zoomindex]);
        this.rebuildGrid(this.getZoomScale());
    }

    setZoomScale (value: number) {
        super.setZoomScale(value);
        //Fire event of scale
        eventsManager.instance.dispatch(Events.ZOOM_SCROLLWIN_CHANGED, value);

        //Notify that grid has moved
        var cSize = this.getContentSize();
        var position = cc.p(cSize.width * 0.5, cSize.height * 0.5);
        var localPosition = this.grid.convertToNodeSpace(position);
        eventsManager.instance.dispatch(Events.POS_WIN_CHANGED, {
            x: localPosition.x,
            y: localPosition.y,
            zoom: this.getZoomScale()
        });
    }

    stopAutoDragging () {
        if (this.isDragging) {
            this.isDragging = false;
        }
    }

    dispose () {
        this.unscheduleUpdate();
        cc.eventManager.removeListener(this.cocosListener);
        eventsManager.instance.removeListener(this.zoomInEvent);
        eventsManager.instance.removeListener(this.zoomOutEvent);
        eventsManager.instance.removeListener(this.overWebGlView);
        eventsManager.instance.removeListener(this.webGlWinChanged);
    }
}
